// extracted by mini-css-extract-plugin
export default {"buttonsHolder":"MqZvewLIK3crHlPSW2Sg","buttonsFull":"UtjlpPvoZ9hbB132WqGC","form":"u8p0F7XspLLMo7_2YlXF"};